/**
 * Inline SVG icons used by `LevelUpUserMenu`'s dropdown rows and trigger chevron. Split out of
 * `levelup-user-menu.tsx` into their own file (this many icons put that file over the repo's
 * `max-lines` lint limit).
 */
export function PortfolioIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M8 1.5V8H14.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ManageAccountIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle
        cx="6.5"
        cy="5.5"
        r="2.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M1.5 14c0-2.485 2.239-4.5 5-4.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle
        cx="12.5"
        cy="9.5"
        r="1.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12.5 6.5V7.5M12.5 11.5V12.5M9.5 9.5H10.5M14.5 9.5H15.5M10.4 7.4L11.1 8.1M13.9 10.9L14.6 11.6M10.4 11.6L11.1 10.9M13.9 8.1L14.6 7.4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function SupportIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M1.5 7.75C1.5 4.16 4.41 1.5 8 1.5s6.5 2.66 6.5 6.25c0 3.36-2.55 5.92-5.86 6.22a.75.75 0 00-.46.2l-1.6 1.47a.4.4 0 01-.67-.29v-1.42a.5.5 0 00-.45-.5C3.02 13.06 1.5 10.7 1.5 7.75z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M6.3 6.3a1.7 1.7 0 113.05 1.03c-.4.5-.85.7-.85 1.42"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle
        cx="8"
        cy="10.9"
        r="0.15"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
}

export function LogOutIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M6.5 14H3.5a1 1 0 01-1-1V3a1 1 0 011-1h3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 11L14 8L10.5 5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 8H6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ChevronDown() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M4 6l4 4 4-4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
